import { OcrReliabilityColorRange } from "../model";
import { evaluateRange } from "../../utils";

export const defaultOcrReliabilityColorRanges: OcrReliabilityColorRange[] = [
  { from: 0, to: 25, value: "#f44336" },
  { from: 25, to: 50, value: "#ff9800" },
  { from: 50, to: 75, value: "#ffeb3b" },
  { from: 75, to: 101, value: "#4caf50" }
];

/**
 * Get the reliability color to indicate the user the level of confidence
 * of the OCR based on the reliability rate and some OCR reliability
 * color ranges.
 *
 * @param reliabilityRate - The reliability rate announced by the OCR for
 * the plate image. Must be between 0 and 100 as it is a percentage.
 * (default to `undefined`)
 * @param ocrReliabilityColorRanges - The OCR reliability color ranges array,
 * you can provide as many ranges as you want, the interval is processed
 * like this : `[from, to[`. (default to `[]`)
 * @returns A color based on the reliability rate announced by the OCR for
 * the plate image or nothing if no reliabilityRate provided are no match found.
 * @throws Will throw an error if the reliabilityRate is less than 0.
 * @throws Will throw an error if the reliabilityRate is greater than 100.
 */
export function getOcrReliabilityColor(
  reliabilityRate?: number,
  ocrReliabilityColorRanges: OcrReliabilityColorRange[] = []
): string | undefined {
  if (reliabilityRate === undefined) return;
  if (reliabilityRate < 0) {
    throw new Error("The reliability rate can't be less than 0");
  }
  if (reliabilityRate > 100) {
    throw new Error("The reliability rate can't be greater than 100");
  }

  for (let i = 0; i < ocrReliabilityColorRanges.length; i++) {
    const ocrReliabilityColorRange: OcrReliabilityColorRange =
      ocrReliabilityColorRanges[i];
    let ocrReliabilityColor: string | undefined;

    try {
      ocrReliabilityColor = evaluateRange<string>(
        reliabilityRate,
        ocrReliabilityColorRange
      );
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error(error);
    }

    if (ocrReliabilityColor !== undefined) return ocrReliabilityColor;
  }

  return;
}

export default getOcrReliabilityColor;
